import { polarClient } from "@polar-sh/better-auth";
import { env } from "@postdaily/env/web";
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: env.VITE_SERVER_URL,
  plugins: [
    polarClient(),
    twoFactorClient({
      // When a password sign-in requires 2FA, send the user to the challenge.
      onTwoFactorRedirect() {
        if (typeof window !== "undefined") {
          window.location.href = "/two-factor";
        }
      },
    }),
  ],
});
